'use client';

import { useEffect } from 'react';
import { type ClientProfilerPageName, registerClientProfilerPage } from '@/src/lib/clientProfiler';

export function ClientProfilerRegistrar({ pageName }: { pageName: ClientProfilerPageName }) {
  useEffect(() => {
    registerClientProfilerPage(pageName);
  }, [pageName]);

  return null;
}
